import { useState } from 'react';
import AgreementTypeService from './AgreementTypeService';

function useManageAgreementTypes() {
    const [agreementTypes, setAgreementTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshAgreementTypes = async () => {
        setIsLoading(true);
        try {
            const response = await AgreementTypeService.getAgreementTypes();
            setAgreementTypes(response.data);
            setError(null);
        } catch (err) {
            console.log(err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const editAgreementType = async (agreementTypeId, updatedData) => {
        setIsLoading(true);
        try {
            await AgreementTypeService.editAgreementType(agreementTypeId, updatedData);
            refreshAgreementTypes();
        } finally {
            setIsLoading(false);
        }
    };

    const publishAgreementVersion = async (agreementTypeId, data) => {
        setIsLoading(true);
        try {
            await AgreementTypeService.publishAgreementVersion(agreementTypeId, data);
            refreshAgreementTypes();
        } finally {
            setIsLoading(false);
        }
    };

    return {
        agreementTypes,
        isLoading,
        error,
        editAgreementType,
        publishAgreementVersion,
        refreshAgreementTypes
    };
}

export default useManageAgreementTypes;
